/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Crear una aplicación con Angular es muy fácil gracias a `}<inlineCode parentName="p">{`@angular/cli`}</inlineCode>{`.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-cli"
      }}><code parentName="pre" {...{
          "className": "language-cli"
        }}>{`npm install -g @angular/cli
ng new mi-nueva-aplicacion`}</code></pre></div>
    <p>{`El CLI de angular tiene superpoderes y continúa siendo de gran utilidad durante el desarrollo, ya que a través de comandos podemos crear componentes, rutas, servicios, test y pipes gracias al comando `}<inlineCode parentName="p">{`ng generate`}</inlineCode>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;